<template>
  <span>
    <check-permission permissions="MESSAGE.ADD" entity-type="profile" :entity-id="receiverId">
      <w-button text="Dodaj przypomnienie" :class="buttonClass" :icon="icon" @click="showAddModal" />
    </check-permission>

    <system-message-modal
      :entity-type="entityType"
      :entity-id="entityId"
      :receiver-id="receiverId"
      :name="name"
      :show="showModal"
      @save="add"
      @close="hideModal"
    />
  </span>
</template>

<script>
import SystemMessageModal from '@/components/modals/SystemMessageModal';
import { modalFormMixin } from '@/mixins/modalForm';
import { getProfileId } from '@/utils/profile';

// @vuese
// Component dodający powiadomienia
// @group Components
export default {
  components: {
    SystemMessageModal
  },
  mixins: [
    modalFormMixin('systemMessage', {
      added: 'Dodano przypomnienie.',
      addError: 'Nie udało się dodać przypomnienia.'
    })
  ],
  props: {
    // Typ powiązanej encji
    entityType: {
      type: String,
      required: true
    },
    // Identyfikator powiązanej encji
    entityId: {
      type: String,
      required: true
    },
    // Identyfikator profilu odbiorcy
    receiverId: {
      type: Number,
      required: false,
      default: () => getProfileId()
    },
    // Nazwa powiadomienia
    name: {
      type: String,
      required: true
    },
    // Klasa przycisku
    buttonClass: {
      type: String,
      required: false,
      default: 'btn btn-warning mr-2'
    },
    // Ikona przycisku
    icon: {
      type: String,
      required: false
    }
  }
};
</script>
